function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["highlighted", "faded"];
import * as React from 'react';
import PropTypes from 'prop-types';
import useControlled from '@mui/utils/useControlled';
import { HighlightedContext } from './HighlightedContext';
import { createIsFaded } from './createIsFaded';
import { createIsHighlighted } from './createIsHighlighted';
import { useSeries } from '../../hooks/useSeries';
import { jsx as _jsx } from "react/jsx-runtime";
const mergeDeprecatedOptions = options => {
  const _ref = options !== null && options !== void 0 ? options : {},
    highlighted = _ref.highlighted,
    faded = _ref.faded,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return _extends({
    highlight: highlighted,
    fade: faded
  }, other);
};
function HighlightedProvider(_ref2) {
  var _seriesById$get;
  let children = _ref2.children,
    highlightedItemProps = _ref2.highlightedItem,
    onHighlightChange = _ref2.onHighlightChange;
  const _useControlled = useControlled({
      controlled: highlightedItemProps,
      default: null,
      name: 'HighlightedProvider',
      state: 'highlightedItem'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    highlightedItem = _useControlled2[0],
    setHighlightedItem = _useControlled2[1];
  const series = useSeries();
  const seriesById = React.useMemo(() => {
    const map = new Map();
    Object.keys(series).forEach(seriesType => {
      var _seriesData$series;
      const seriesData = series[seriesType];
      Object.keys((_seriesData$series = seriesData === null || seriesData === void 0 ? void 0 : seriesData.series) !== null && _seriesData$series !== void 0 ? _seriesData$series : {}).forEach(seriesId => {
        const seriesItem = seriesData === null || seriesData === void 0 ? void 0 : seriesData.series[seriesId];
        map.set(seriesId, mergeDeprecatedOptions(seriesItem === null || seriesItem === void 0 ? void 0 : seriesItem.highlightScope));
      });
    });
    return map;
  }, [series]);
  const highlightScope = highlightedItem && highlightedItem.seriesId ? (_seriesById$get = seriesById.get(highlightedItem.seriesId)) !== null && _seriesById$get !== void 0 ? _seriesById$get : undefined : undefined;
  const providerValue = React.useMemo(() => {
    return {
      isInitialized: true,
      data: {
        highlightScope,
        highlightedItem,
        setHighlighted: itemData => {
          setHighlightedItem(itemData);
          onHighlightChange === null || onHighlightChange === void 0 ? void 0 : onHighlightChange(itemData);
        },
        clearHighlighted: () => {
          setHighlightedItem(null);
          onHighlightChange === null || onHighlightChange === void 0 ? void 0 : onHighlightChange(null);
        },
        isHighlighted: createIsHighlighted(highlightScope, highlightedItem),
        isFaded: createIsFaded(highlightScope, highlightedItem)
      }
    };
  }, [highlightedItem, highlightScope, setHighlightedItem, onHighlightChange]);
  return /*#__PURE__*/_jsx(HighlightedContext.Provider, {
    value: providerValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? HighlightedProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: PropTypes.shape({
    dataIndex: PropTypes.number,
    seriesId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: PropTypes.func
} : void 0;
export { HighlightedProvider };